import { trackClicked } from '#/utils/analytics/track/trackClicked';

import {
  PageFooterVolunteeringLinksHolder,
  PageFooterVolunteeringLinksItem,
  PageFooterVolunteeringLinksList,
  PageFooterVolunteeringLinksTitle,
} from './PageFooterVolunteeringLinks.styled';
import { pageFooterVolunteeringLinksData } from './pageFooterVolunteeringLinksData';

export function PageFooterVolunteeringLinks() {
  return (
    <PageFooterVolunteeringLinksHolder>
      <PageFooterVolunteeringLinksTitle>
        Local Volunteer Opportunities
      </PageFooterVolunteeringLinksTitle>

      <PageFooterVolunteeringLinksList>
        {pageFooterVolunteeringLinksData.map((data) => (
          <PageFooterVolunteeringLinksItem
            key={data.title}
            to={data.href}
            onClick={() => {
              trackClicked('Local Volunteer Opp', {
                url: data.href,
                context: 'Footer',
              });
            }}
          >
            {data.title}
          </PageFooterVolunteeringLinksItem>
        ))}
      </PageFooterVolunteeringLinksList>
    </PageFooterVolunteeringLinksHolder>
  );
}
